module.exports = __webpack_public_path__ + "static/media/search-normal-gray.f5a4f2c2.svg";